// extracted by mini-css-extract-plugin
export default {"wrap":"PayIcons_wrap__CA1Hs","wrapIconLarge":"PayIcons_wrapIconLarge__0D+BI","wrapFullWidth":"PayIcons_wrapFullWidth__hnf0H"};